/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { useStrategySchemaV2 } from '../../../hooks/useStrategySchemaV2';

export default function SchemaStatusBanner() {
  const { loading, error, schemaHash, normalized } = useStrategySchemaV2() || {};

  if (loading) {
    return (
      <div className="border rounded-md p-2.5 bg-muted/30 text-[11px]" id="schema-status">
        Loading schema…
      </div>
    );
  }
  if (error) {
    return (
      <div className="border rounded-md p-2.5 bg-red-500/10 text-[11px] text-red-700" id="schema-status">
        Failed to load schema. Check backend connectivity.
      </div>
    );
  }

  const ind = normalized?.indicators?.length || 0;
  const ops = normalized?.operators?.length || 0;
  const act = normalized?.actions?.length || 0;
  const total = ind + ops + act;

  return (
    <div className="border rounded-md p-2.5 bg-card text-[11px] flex items-center gap-3" id="schema-status">
      <span className="text-textSecondary">Schema:</span>
      {schemaHash ? (
        <span className="font-mono text-textSecondary/80" title={schemaHash}>{schemaHash.slice(0, 12)}</span>
      ) : (
        <span className="text-textSecondary/60">no hash</span>
      )}
      <span className="ml-2">•</span>
      <span>{total} nodes</span>
      <span className="text-textSecondary">(Indicators {ind}, Operators {ops}, Actions {act})</span>
      {total === 0 && (
        <span className="ml-auto text-amber-600">No nodes parsed from schema</span>
      )}
    </div>
  );
}
